import cookie from './storageMode/cookie';
import sessionStorage from './storageMode/sessionStorage';
import localStorage from './storageMode/localStorage';

export default {
  cookie,
	localStorage,
	sessionStorage,
};
